module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/voice-logo-nice-0e292a6eb35ef99371a270b5f8c8c6b8.svg";